var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// - Import react components
import { db } from 'data/firestoreClient';
import { SocialError } from 'core/domain/common';
import { injectable } from 'inversify';
/**
 * Firbase vote service
 *
 * @export
 * @class VoteService
 * @implements {IVoteService}
 */
var VoteService = /** @class */ (function () {
    function VoteService() {
        this.addVote = function (vote) {
            return new Promise(function (resolve, reject) {
                var postRef = db.doc("posts/" + vote.postId);
                var voteRef = postRef.collection("votes").doc(vote.userId)
                    .set(__assign({}, vote));
                voteRef.then(function (result) {
                    resolve();
                    /**
                     * Add score
                     */
                    db.runTransaction(function (transaction) {
                        return transaction.get(postRef).then(function (postDoc) {
                            if (postDoc.exists) {
                                var post = postDoc.data();
                                var votes = post.votes, score = post.score;
                                if (!votes) {
                                    votes = {};
                                }
                                if (!score) {
                                    score = 0;
                                }
                                var newScore = score + 1;
                                votes[vote.userId] = true;
                                transaction.update(postRef, { votes: __assign({}, votes), score: newScore });
                            }
                        });
                    });
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        this.getVotes = function (postId) {
            return new Promise(function (resolve, reject) {
                var votesRef = db.doc("posts/" + postId).collection("votes");
                votesRef.onSnapshot(function (snapshot) {
                    var _a;
                    var parsedData = (_a = {}, _a[postId] = {}, _a);
                    snapshot.forEach(function (result) {
                        parsedData[postId][result.id] = __assign({}, result.data());
                    });
                    resolve(parsedData);
                });
            });
        };
        this.deleteVote = function (userId, postId) {
            return new Promise(function (resolve, reject) {
                var batch = db.batch();
                var postRef = db.doc("posts/" + postId);
                var voteRef = postRef.collection("votes").doc(userId);
                batch.delete(voteRef);
                batch.commit().then(function () {
                    resolve();
                    /**
                     * Remove score
                     */
                    db.runTransaction(function (transaction) {
                        return transaction.get(postRef).then(function (postDoc) {
                            if (postDoc.exists) {
                                var post = postDoc.data();
                                var votes = post.votes, score = post.score;
                                if (!votes) {
                                    votes = {};
                                }
                                if (!score) {
                                    score = 0;
                                }
                                var newScore = score - 1;
                                votes[userId] = false;
                                transaction.update(postRef, { votes: __assign({}, votes), score: newScore });
                            }
                        });
                    });
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
    }
    VoteService = __decorate([
        injectable()
    ], VoteService);
    return VoteService;
}());
export { VoteService };



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/services/votes/VoteService.ts
// module id = 305
// module chunks = 50